<mat-toolbar class="no-background">
  <span>振替依頼の作成</span>
  <span class="spacer"></span>
  <a mat-button class="add-link" routerLink="/transfer">
    <mat-icon>arrow_back</mat-icon>作成せずに戻る
  </a>
</mat-toolbar>

<form [formGroup]="form" (ngSubmit)="submit()" enctype="multipart/form-data">

  <pre>このフォームへの入力と同時に申込書類のアップロードが必要となります。
お申し込み書類は紛失されないようお願いします。
お申し込み内容の取消が必要な場合は、作成後に確認できる詳細画面からお願いします。
（但し、事務処理の進捗状況によっては、取消を承れない場合もございます。）</pre>
<br>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>振替元となる出資口座番号（50文字まで）</mat-label>
    <input matInput formControlName="acc" maxlength="50" required>
    <mat-hint align="end">
      <span *ngIf="form.get('acc')?.hasError('maxlength') && form.get('acc')?.touched" class="inline-error">
        口座番号は50文字以内で入力してください　
      </span>
      {{ form.get('acc')?.value?.length || 0 }}/50
    </mat-hint>
    <pre>出資口座番号をご記入ください。複数ある場合はカンマ区切りでご記入ください。
（例）AA0123-0,BB3456-1,XX9988-9</pre>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>振替先のプラン名</mat-label>
    <mat-select formControlName="pool">
      <mat-option *ngFor="let type of TransferPoolTypes" [value]="type" >{{type}}</mat-option>
    </mat-select>
    <mat-hint align="end">
      <span *ngIf="form.get('pool')?.invalid && form.get('pool')?.touched" class="inline-error">
        振替先のプラン名は必須です　
      </span>
      <span *ngIf="form.get('pool')?.value && form.get('pool')?.value !== 'CHFX'" class="inline-error">
        2025年7月現在、CHFX以外へのお振替はおよそ3か月間お待ちいただいております。ご注意ください。　
      </span>
    </mat-hint>
  </mat-form-field>

  <input type="file" #fileInput hidden multiple (change)="onFileChange($event)"/>

  <pre>振替お申し込み書類のアップロード *

必要書類は、「(1) 振替元の解約出金依頼書  」と「(2) 振替先の新規申込書  」の2種類となります。

１枚目　振替元の解約出金依頼書　<a href="https://fxwiz.info/documents/Withdrawal.pdf" target="_blank">ダウンロード</a>
２枚目　振替先の新規申込書　<a href="https://myfxpool.com/application2" target="_blank">ダウンロード</a>

<a href="https://fxwiz.info/documents/sample-furikae1.png" target="_blank">解約出金依頼書の記入方法サンプル　（必ずご確認ください）</a>
<a href="https://fxwiz.info/documents/sample-furikae2.png" target="_blank">振替先の申込書の記入方法サンプル　（必ずご確認ください）</a>

出資口座が複数ある場合でも上記の２枚の書類として記入をおまとめください。</pre>

  <div
    class="drop-zone"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
  >
    <p>ここにファイルをドロップまたは</p>
    <button mat-raised-button color="primary" type="button" (click)="fileInput.click()">ファイルを選択</button>
    <p></p>
    <p>※ファイルは最大10個まで、1ファイルにつき20MB以内でアップロードしてください</p>

    <div *ngIf="selectedFiles.length > 0" class="mt-2">
      <mat-list>
        <mat-list-item *ngFor="let file of selectedFiles; let i = index">
          <div class="file-row">
            <button mat-icon-button color="warn" type="button" (click)="removeFile(i)" aria-label="削除">
              <mat-icon>delete</mat-icon>
            </button>
            <span class="file-size">
              ({{ file.size / (1024 * 1024) | number : '1.2-2' }} MB)
            </span>
            <span class="file-name">
              {{ file.name }}
            </span>
          </div>
        </mat-list-item>
      </mat-list>
    </div>

  </div>

  <mat-error *ngIf="form.get('files')?.hasError('maxFileSize')">
    {{ form.get('files')?.getError('maxFileSize')?.message }}
  </mat-error>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>補足（400文字まで・補足がござましたらこちらからどうぞ）</mat-label>
    <textarea matInput formControlName="body" rows="6"></textarea>
    <mat-hint align="end">
      <span *ngIf="form.get('body')?.hasError('maxlength') && form.get('body')?.touched" class="inline-error">
        補足は400文字以内で入力してください　
      </span>
      {{ form.get('body')?.value?.length || 0 }}/400
    </mat-hint>
  </mat-form-field>

  <pre>お申し込みに対する当社の対応は、平日営業時間帯での対応となります。
お申込みは毎月20日で締め切られます。21日のお申込みは翌月お取り扱い分となります。</pre>

  <div style="text-align: right;">
    <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">
      振替依頼を作成
    </button>
  </div>

</form>
